module.exports = __webpack_public_path__ + "img/category-new-released-hover.6b7f3be8.png";